import { useTheme, useMediaQuery } from '@mui/material';

// Hook for getting responsive chart configuration
export const useChartConfig = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  // Responsive chart margins
  const chartMargins = {
    xs: { top: 5, right: 5, left: 5, bottom: 5 },
    sm: { top: 5, right: 15, left: 15, bottom: 5 },
    md: { top: 5, right: 20, left: 20, bottom: 5 },
    lg: { top: 5, right: 25, left: 25, bottom: 5 }
  };

  const currentMargins = isSmallScreen ? chartMargins.xs : 
                        isMediumScreen ? chartMargins.sm : 
                        chartMargins.md;

  return {
    height: 400,
    margins: currentMargins,
    containerProps: {
      width: "100%",
      height: 400
    }
  };
};

// Default chart colors
export const CHART_COLORS = {
  primary: '#1976d2',
  secondary: '#dc004e',
  success: '#2e7d32',
  warning: '#ed6c02',
  error: '#d32f2f',
  info: '#0288d1',
  // Additional colors for multiple series
  series1: '#1976d2',
  series2: '#dc004e',
  series3: '#2e7d32',
  series4: '#ed6c02',
  series5: '#d32f2f',
  series6: '#0288d1',
  series7: '#7b1fa2',
  series8: '#388e3c',
  series9: '#f57c00',
  series10: '#5d4037',
};

// Common chart styling
export const CHART_STYLES = {
  paper: {
    p: 2,
    mb: 3,
    width: '100%',
    overflow: 'hidden'
  },
  chartContainer: {
    width: '100%',
    height: 400
  },
  chartTitle: {
    mb: 2,
    fontWeight: 600
  }
};

export default useChartConfig;